import ControllerBase from '../../../../global/js/ControllerBase';
import { fromEvent } from 'rxjs';
import { OrganismShoppingCartEvents } from '../../organisms/o-shopping-cart/o-shopping-cart.events';

export default class ControllerProductDetails extends ControllerBase {
	/** A list of dom element references available to this component */
	private readonly componentRefs = {
		addToCart: 'addToCart',
		quantity: 'quantity',
		productId: 'productId',
	};

	constructor(element: HTMLElement) {
		super(element);
		this.registerEventListeners();
	}

	private registerEventListeners(): void {
		this.registerAddToCartEvent();
	}

	/**
	 * Watch for clicks to the add to cart button
	 * @returns void
	 */
	private registerAddToCartEvent(): void {
		if (Object.prototype.hasOwnProperty.call(this.$references.hasOwnProperty, this.componentRefs.addToCart)) {
			/** Event handler for when the button is clicked*/
			const onAddToCartClick = fromEvent(this.$references[this.componentRefs.addToCart], 'click');

			onAddToCartClick.subscribe((e: Event | any) => {
				// console.log('addToCart');
				e.preventDefault();
				if (e && e.target) {
					const quantity = +(<HTMLInputElement>this.$references[this.componentRefs.quantity]).value;
					const productId = (<HTMLInputElement>this.$references[this.componentRefs.productId]).value;

					// build event data
					const eventDetail: {
						productId: string;
						quantity: number;
					} = {
						productId: productId,
						quantity: quantity,
					};
					this.dispatchCustomEvent(OrganismShoppingCartEvents.addToCart, eventDetail, true);
				}
			});
		}
	}
}
